// Minimal IndexedDB wrapper for the Beta Listener offline layer.
const DB_NAME = "hd_listen";
const DB_VERSION = 2;
const STORES = ["audio", "outbox", "progress", "meta", "feedback"];

let _dbp = null;
function db() {
  if (_dbp) return _dbp;
  _dbp = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const d = req.result;
      STORES.forEach((s) => { if (!d.objectStoreNames.contains(s)) d.createObjectStore(s, { keyPath: "key" }); });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return _dbp;
}

async function tx(store, mode, fn) {
  const d = await db();
  return new Promise((resolve, reject) => {
    const t = d.transaction(store, mode);
    const os = t.objectStore(store);
    let out;
    Promise.resolve(fn(os)).then((r) => { out = r; }).catch(reject);
    t.oncomplete = () => resolve(out);
    t.onerror = () => reject(t.error);
    t.onabort = () => reject(t.error);
  });
}

const req2p = (r) => new Promise((res, rej) => { r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error); });

export const idbGet = (store, key) => tx(store, "readonly", (os) => req2p(os.get(key)));
export const idbAll = (store) => tx(store, "readonly", (os) => req2p(os.getAll()));
export const idbPut = (store, value) => tx(store, "readwrite", (os) => req2p(os.put(value)));
export const idbDel = (store, key) => tx(store, "readwrite", (os) => req2p(os.delete(key)));
export const idbClear = (store) => tx(store, "readwrite", (os) => req2p(os.clear()));

export async function metaGet(key, fallback = null) {
  const r = await idbGet("meta", key);
  return r ? r.value : fallback;
}
export const metaSet = (key, value) => idbPut("meta", { key, value });
